// TODO: udělat pořádek v modelech!!!
export class FormField {
    id: string;
    label: string;
    labelFalse?: string;
    type: string;
    defaultValue: any;
    required: boolean;
    fieldoptions: Array<string>;
    position: number;
    language: string;
    options?: { text: string, value: string }[];
    fieldIndex: number;


    constructor(options: any) {
        this.id = options.id;
        this.label = options.label;
        this.labelFalse = options.labelFalse;
        this.type = options.type;
        this.defaultValue = options.defaultValue;
        this.required = options.required;
        this.fieldoptions = options.fieldoptions;
        this.position = options.position;
        this.language = options.language;
        this.fieldoptions = options.fieldoptions;
        this.options = options.options;
        this.fieldIndex = options.fieldIndex;
    }
}

export class FormFieldOptions {
    public static options: { text: string, value: string }[] = [
        {
            text: 'Jednořádkový text',
            value: 'text'
        },
        {
            text: 'Víceřádkový text',
            value: 'textarea'
        },
        {
            text: 'Checkbox (zaškrtávátko)',
            value: 'checkbox'
        },
        {
            text: 'E-mail',
            value: 'email'
        },
        {
            text: 'Telefonní číslo',
            value: 'tel'
        },
        {
            text: 'Výběr z možností (select box)',
            value: 'select'
        }
    ];
}
